'use client';

import { useCart } from "@/contexts/cart-context";
import { useTranslations } from "next-intl";
import BreadcrumbCart from "../cart-page/breadcrumb-cart";
import CartProductList from "./cart-product-list";
import CheckoutButton from "../buttons/checkout-button";
import PromoCodeForm from "../forms/promo-code-form";
import CartSummaryDetails from "./cart-summary-details";
import EmptyCart from "./empty-cart";

export default function CartClient() {
  const t = useTranslations("ui");
  const {
    cartItems,
    totalPrice,
    increaseItem,
    decreaseItem,
    removeItem,
    handleCheckout,
  } = useCart();

  const adjustedTotalPrice = totalPrice;

  if (cartItems.length === 0) {
    return (
      <div className="max-w-[1280px] mx-auto px-4 xl:px-0">
        <EmptyCart />
      </div>
    );
  }

  return (
    <div className="max-w-[1280px] mx-auto px-4 xl:px-0">
      <BreadcrumbCart home={t("home")} cart={t("cart")} />
      <h2 className="font-bold text-[32px] md:text-[40px] text-black uppercase mb-5 md:mb-6">{t("shopping_cart")}</h2>
      <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-5 items-start">
        <CartProductList
          items={cartItems}
          onIncrease={increaseItem}
          onDecrease={decreaseItem}
          onRemove={removeItem}
        />
        <div className="w-full lg:max-w-[505px] p-5 md:px-6 flex flex-col space-y-4 md:space-y-6 rounded-[20px] border border-black/10">
          <h6 className="text-xl md:text-2xl font-bold text-black">{t("order_summary")}</h6>
          <CartSummaryDetails
            totalPrice={totalPrice}
            adjustedTotalPrice={adjustedTotalPrice}
          />
          <PromoCodeForm />
          <CheckoutButton
            isLoading={false}
            onCheckout={handleCheckout}
          />
        </div>
      </div>
    </div>
  );
}